import type { FlowVoiceConfig, LanguageConfig } from './types';
import { defaultFlowVoiceConfig } from './voicePresets';

export function isElevenLabsVoiceConfig(voiceConfig: FlowVoiceConfig | undefined): boolean {
  return voiceConfig?.voiceType === 'premium';
}

export function flowUsesElevenLabsVoice(
  voiceConfig: FlowVoiceConfig | undefined,
  languageConfig: LanguageConfig | undefined,
): boolean {
  if (isElevenLabsVoiceConfig(voiceConfig)) {
    return true;
  }

  return languageConfig?.languages.some((language) => isElevenLabsVoiceConfig(language.voiceConfig)) ?? false;
}

export function getVoiceAttributes(
  voiceConfig: FlowVoiceConfig | undefined,
  languageCode?: string,
  languageConfig?: LanguageConfig,
  elevenLabsApiKeyRef?: string,
): Record<string, string | undefined> {
  let config = voiceConfig ?? defaultFlowVoiceConfig;

  if (languageCode && languageConfig) {
    const langEntry = languageConfig.languages.find((l) => l.code === languageCode);
    if (langEntry?.voiceConfig) {
      config = langEntry.voiceConfig;
    }
  }

  if (config.voiceType === 'premium' && config.modelId) {
    return {
      voice: `ElevenLabs.${config.modelId}.${config.voiceId}`,
      api_key_ref: elevenLabsApiKeyRef,
    };
  }

  return {
    voice: config.voiceId,
    language: config.language,
  };
}
